module.exports = __webpack_public_path__ + "static/media/Gallery_2-min.4c8c88a2.jpg";